import { Box, Typography } from '@mui/material';
import React from 'react';
import { ccyFormat } from '../../../../helpers/helper';
import DataCollapse from '../../../DataCollapse';
import MixedPaymentsDetail from './MixedPaymentsDetail';
import SaleActions from './SaleActions';
import SaleTitle from './SaleTitle';

const SaleRow = ({
    sale,
    readonly,
    onReturnItem,
    onDelete,
    onReserve,
    onReturn,
    onPreviewTicket,
    stylePast16,
    getPendingBySale,
    renderItemTitleWithOver
}) => {
    const hasMixedPayments = sale.payments && sale.payments[0].amount > 0 && sale.payments[1].amount > 0

    return (
        <Box display='flex' paddingX={0} margin={0}>
            <Typography display='flex' flexDirection='row' justifyContent='space-between' variant='inherit' width='100%' alignItems='center'>
                <Box>
                    {hasMixedPayments ?
                        <DataCollapse
                            readonly={readonly}
                            Header={() => <SaleTitle sale={sale} renderItemTitleWithOver={renderItemTitleWithOver} />}
                            Content={() => <MixedPaymentsDetail sale={sale} getPendingBySale={getPendingBySale} />}
                        />
                        : <Typography
                            onClick={() => window.open(`${sale.article.images && sale.article.images[0]}`, '_blank')}
                        >
                            <SaleTitle sale={sale} renderItemTitleWithOver={renderItemTitleWithOver} />
                        </Typography>}
                </Box>
                <Box display='flex' flexDirection='row'>
                    <span>{ccyFormat(sale.prices_sold.sale_price * sale.quantity_sold)}</span>
                    <Box sx={{ ...stylePast16(sale.updated_at), width: 5, marginLeft: 1 }} />
                    <SaleActions
                        sale={sale}
                        readonly={readonly}
                        onReturnItem={onReturnItem}
                        onDelete={() => onDelete(sale)}
                        onReserve={() => onReserve(sale)}
                        onReturn={() => onReturn(sale)}
                        onPreviewTicket={onPreviewTicket}
                    />
                </Box>
            </Typography>
        </Box>
    )
}

export default SaleRow;
